import React from "react";
import * as agent from "../agent";
import PrintLink from './PrintLink';

export default ({ id, isJur, programType, trader, tradeStatus, carId }) => {
    return (
        <React.Fragment>
            <PrintLink href={agent.src.print("contract", id)}
                       label="ДКП" />
            <PrintLink href={agent.src.print("inspection", id) }
                       label="Акт осмотра" />
            <PrintLink href={agent.src.print("transfer", id)}
                       label="Акт приема-передачи" />
            <PrintLink href={agent.src.print("extra", id)}
                       label="Доп. соглашение" />
            { programType === "PTS" &&
                <PrintLink href={agent.src.print("stuff", id)}
                           label="Займ + залог" />
            }
            { tradeStatus === "SECOND" &&
                <PrintLink href={agent.src.print(trader === "AF" ? "sale" : "salep2p", carId)}
                           label="Продажа: ДКП" />
            }
            { isJur ?
                <PrintLink href={agent.src.print("income_order", id) }
                           label="Приходный ордер" /> :
                <PrintLink href={agent.src.print("order", id) }
                           label="Расходный ордер" />
            }
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/components/PrintLinks.js